// extracted by mini-css-extract-plugin
export default {"status":"RegionDate_status__QfVdI","Live":"RegionDate_Live__FhLKu","Activates":"RegionDate_Activates__zLiK3","wrapper":"RegionDate_wrapper__OL0fx","text":"RegionDate_text__J40e4"};